export default __webpack_public_path__ + "static/media/spring.df5563fb.svg";